import React, { PureComponent } from 'react';
import styles from './index.css';
import MouseCodeImg from '../mouseCodeImg/';

/**
 * 提示：试看五分钟
 */
class ShortTips extends PureComponent {

  constructor(props) {
    
    super(props);

    this.state = {
      codeImgShow: false,
    }
  }

  handleMouseEnter = () => {
    this.setState({
      codeImgShow: true,
    })
  }

  handleMouseLeave = () => {
    this.setState({
      codeImgShow: false,
    })
  }

  render() {

    const { qrImgContent, closureTime } = this.props;

    return (
      <div className={styles.shortTipsPc}>
        可试看 {closureTime} 秒，使用  
        <span className={styles.fhxwkhdPc} 
              onMouseEnter={this.handleMouseEnter} 
              onMouseLeave={this.handleMouseLeave}
        >手机端</span>  观看完整版
        { this.state.codeImgShow && qrImgContent && <MouseCodeImg qrImgContent={qrImgContent}/> }
      </div>
      );
  }
}

export default ShortTips;
